// @core/api/endpoints/document/update_document_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentTypeDefinitionResponse,
  UpdateDocumentTypeRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update document type
 * Updates a document type definition (workflow defaults, numbering, lifecycle flags).
 */
export async function UpdateDocumentType(
  type_id: string,
  data: UpdateDocumentTypeRequest,
  options?: RequestOptions
): Promise<DocumentTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.put<DocumentTypeDefinitionResponse>(requestPath, data, requestOptions);
}
